import React from "react";
import { NavLink, Link } from "react-router-dom";




/*const handlePush = async event => {
  event.preventDefault();
try {
  var win = window.open("http://idms-venture-filali.com.s3-website-us-west-2.amazonaws.com/", '_blank');
  win.focus();
}catch(error) {
  console.log(error.message);
}
};*/



/*
          <NavLink
            exact
            to="/home"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            About Us
          </NavLink>

           <NavLink
            exact
            to="/dashboard"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            Dashboard
          </NavLink>

          <NavLink
            exact
            to="/login"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            Login
          </NavLink>

*/




  function handleClick(e) {    
    e.preventDefault();    
    //window.location = "http://idms-streaming-filali.com.s3-website-us-west-2.amazonaws.com/";    
    window.open("http://app.idms-invest.com","_blank");
  }


const Navbah = () => {


 // openInNewTab= async event =>  {




  return (
      <nav className="navbar navbar-expand-lg navbar-dark  shadow-lg main-navbar">

      <a  className="logo"   rel="noopener noreferrer"><img src="./pictures/images_10.jpg" height="60px" width="120px" alt="iDMS" ></img><p  className ="logoname" >iDMS Investment - Cloud-based Trading Intelligence Platform</p></a>


      
      <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div className="navbar-nav ml-auto">

    
          <NavLink
            exact
            to="/home"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            Home
          </NavLink>

          <NavLink
            exact
            to="/solution"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            Solution
          </NavLink>

          <NavLink
            exact
            to="/product"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            Product
          </NavLink>

          <NavLink
            exact
            to="/Pricing"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            Pricing
          </NavLink>

         

          <NavLink
            exact
            to="/Contact"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            Contact Us
          </NavLink>

         {/*} <NavLink
            exact
            to="/admin_dashboard"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            Admin Dashboard
          </NavLink>

          <NavLink
            exact
            to="/login"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            Login
          </NavLink>

           <NavLink
            exact
            to="/user_dashboard"
            className="nav-item nav-link"
            activeClassName="nav-item nav-link active"
            cursor= "pointer"
          >
            Dashboard
          </NavLink> */}






        </div>
        &nbsp;&nbsp; &nbsp;&nbsp; 

        <button id="myButton" width = "100px"   onClick={handleClick}  className = "button_login_app"  href="http://app.idms-invest.com.s3-website-us-west-2.amazonaws.com/" target ="_blank" rel="noopener noreferrer" >Sign In to the application!</button>

      </div>
    </nav>
  );
};



export default Navbah;
